/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The TriggersEventsBody model module.
 * @module model/TriggersEventsBody
 * @version 1.0.0
 */
export class TriggersEventsBody {
  /**
   * Constructs a new <code>TriggersEventsBody</code>.
   * @alias module:model/TriggersEventsBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>TriggersEventsBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TriggersEventsBody} obj Optional instance to populate.
   * @return {module:model/TriggersEventsBody} The populated <code>TriggersEventsBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TriggersEventsBody();
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('type'))
        obj.type = ApiClient.convertToType(data['type'], 'String');
      if (data.hasOwnProperty('globalType'))
        obj.globalType = ApiClient.convertToType(data['globalType'], 'String');
      if (data.hasOwnProperty('propertyId'))
        obj.propertyId = ApiClient.convertToType(data['propertyId'], 'String');
      if (data.hasOwnProperty('enabled'))
        obj.enabled = ApiClient.convertToType(data['enabled'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {String} title
 */
TriggersEventsBody.prototype.title = undefined;

/**
 * @member {String} description
 */
TriggersEventsBody.prototype.description = undefined;

/**
 * Allowed values for the <code>type</code> property.
 * @enum {String}
 * @readonly
 */
TriggersEventsBody.TypeEnum = {
  /**
   * value: "subscribe"
   * @const
   */
  subscribe: "subscribe"
};
/**
 * @member {module:model/TriggersEventsBody.TypeEnum} type
 */
TriggersEventsBody.prototype.type = undefined;

/**
 * Allowed values for the <code>globalType</code> property.
 * @enum {String}
 * @readonly
 */
TriggersEventsBody.GlobalTypeEnum = {
  /**
   * value: "none"
   * @const
   */
  none: "none",

  /**
   * value: "global"
   * @const
   */
  global: "global",

  /**
   * value: "property"
   * @const
   */
  property: "property"
};
/**
 * @member {module:model/TriggersEventsBody.GlobalTypeEnum} globalType
 */
TriggersEventsBody.prototype.globalType = undefined;

/**
 * @member {String} propertyId
 */
TriggersEventsBody.prototype.propertyId = undefined;

/**
 * @member {Boolean} enabled
 */
TriggersEventsBody.prototype.enabled = undefined;

